// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"
// eagerLoadControllersFrom("controllers", application)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import NestedFormController from "./nested_form_controller"
application.register("nested_form", NestedFormController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import RenameModalController from "./rename_modal_controller"
application.register("rename_modal", RenameModalController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FormDirtyController from "./form_dirty_controller"
application.register("form-dirty", FormDirtyController)

import TalentBadgeController from "./talent_badge_controller"
application.register("talent-badge", TalentBadgeController)

import RoleSectionsController from "./role_sections_controller"
application.register("role-sections", RoleSectionsController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

// Make the Stimulus application globally accessible for debugging
// window.Stimulus = { application }

import ConditionalRequiredController from "./conditional_required_controller"
application.register("conditional-required", ConditionalRequiredController)

import ThemeSwitcherController from "./theme_switcher_controller"
application.register("theme-switcher", ThemeSwitcherController)

import TalentSectionsController from "./talent_sections_controller"
application.register("talent-sections", TalentSectionsController)
